/**
 * Consent- und Profil-Konstanten der Registrierung.
 *
 * Die Werte gehen als User-Metadata an supabase.auth.signUp() und werden
 * dort vom Trigger handle_new_user (Migration 169) in die Profilzeile
 * geschrieben. Sie stehen hier zentral, damit die Version, der ein Nutzer
 * zugestimmt hat, nicht an mehreren Stellen im Code driftet.
 *
 * Wird ein Rechtstext geaendert, muss die zugehoerige Version hier hoch -
 * nur so laesst sich spaeter feststellen, wer noch der alten Fassung
 * zugestimmt hat.
 */
export const CONSENT_VERSIONS = {
  /** Datenschutzerklaerung */
  privacy: '1.0',
  /** AGB / Nutzungsbedingungen */
  terms: '1.0',
  /** Einwilligung in die Verarbeitung von Gesundheitsdaten (DSGVO Art. 9) */
  healthData: '1.0',
} as const;

/**
 * Fallback, wenn der Browser keine Zeitzone liefert. Entspricht dem
 * Spalten-Default von profiles.timezone (Migration 124).
 */
export const DEFAULT_TIMEZONE = 'Europe/Berlin';
